import type { FleetV2Response } from '@emma/api_client/types';
import { Link, Text } from '@lego/klik-ui';
import { Link as ReactRouterLink } from 'react-router-dom';
import { UserNameLink } from '@/components/common/UserNameLink';
import { dateTimeFormat } from '@/utility/date';
import { paths } from '@/utility/global_paths';
import { PlaceholderText } from '../../PlaceholderText';
import { createColumnHelper } from '../appTable';

const columnHelper = createColumnHelper<FleetV2Response>();

export const fleetTableColumns = columnHelper.columns([
  columnHelper.accessor('id', {
    cell: (info) => (
      <Text fontFamily="mono" fontSize="sm">
        {info.getValue()}
      </Text>
    ),
    header: 'ID',
    meta: { filterVariant: { constraint: /^[0-9]*$/, type: 'singleSearch' } },
    size: 50,
  }),
  columnHelper.accessor('name', {
    cell: (info) => info.getValue(),
    header: 'Name',
    meta: { filterVariant: { type: 'singleSearch' } },
  }),
  columnHelper.accessor('description', {
    cell: (info) => info.getValue(),
    enableSorting: false,
    header: 'Description',
  }),
  columnHelper.accessor('activeDeploymentId', {
    cell: (info) => {
      const deploymentId = info.getValue();
      const fleet = info.row.original;
      return deploymentId != null ? (
        <Link
          as={ReactRouterLink}
          p={0}
          to={paths.deploymentById(fleet.workspaceId, fleet.id, deploymentId)}
        >
          {deploymentId}
        </Link>
      ) : (
        <PlaceholderText>No active deployment</PlaceholderText>
      );
    },
    enableSorting: false,
    header: 'Active Deployment ID',
    size: 200,
  }),
  columnHelper.accessor('createdByOid', {
    cell: (info) => <UserNameLink oid={info.getValue()} />,
    enableSorting: false,
    header: 'Created By',
  }),
  columnHelper.accessor('createdAt', {
    cell: (info) => new Date(info.getValue()).toLocaleString(dateTimeFormat.local),
    header: 'Created At',
    meta: { filterVariant: { type: 'dateRange' } },
  }),
]);
